module.exports = __webpack_public_path__ + "img/Wp_2002.c5dae688.png";